(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-brand-select"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mobile-brand-select]');
    if (!select || !select.value) return;
    window.location.href = select.value;
  });
  } catch(e) { console.error(e); }
})();

})();
